import { View } from './view'

export const Product = View
